import React from 'react';
import ServicesComponent from '../components/Services';

function Services() {
  return (
    <div className="animate-fade-in-up">
      <ServicesComponent />
    </div>
  );
}

export default Services;
